import { render, staticRenderFns } from "./VPagination.vue?vue&type=template&id=7f83a66b&scoped=true&"
import script from "./VPagination.vue?vue&type=script&lang=js&"
export * from "./VPagination.vue?vue&type=script&lang=js&"
import style0 from "./VPagination.vue?vue&type=style&index=0&id=7f83a66b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f83a66b",
  null
  
)

export default component.exports